module.exports = __webpack_public_path__ + "static/media/active-user-qr.91eb9999.png";